<script setup>
import { useI18n } from 'vue-i18n';
import LaisHeader from 'dashboard/components-next/LaisHeader.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  canDeliver: { type: Boolean, default: false },
  canSave: { type: Boolean, default: false },
  canViewSummary: { type: Boolean, default: false },
  delivering: { type: Boolean, default: false },
  saving: { type: Boolean, default: false },
});

const emit = defineEmits(['back', 'deliver', 'save', 'summary']);
const { t } = useI18n();
</script>

<template>
  <LaisHeader
    :title="t('SALES.DELIVERY.TITLE')"
    :subtitle="t('SALES.DELIVERY.SUBTITLE')"
    :breadcrumb="[
      { label: t('SALES.TITLE') },
      { label: t('SALES.DELIVERY.TITLE') },
    ]"
    show-back
    :back-label="t('SALES.ACTIONS.BACK')"
    @back="emit('back')"
  >
    <template #actions>
      <LaisPrimaryButton
        variant="ghost"
        icon="i-lucide-rocket"
        :disabled="!canViewSummary"
        @click="emit('summary')"
      >
        {{ t('SALES.DELIVERY.SUMMARY.ACTION') }}
      </LaisPrimaryButton>
      <LaisPrimaryButton
        variant="ghost"
        icon="i-lucide-save"
        :is-loading="saving"
        :disabled="!canSave"
        @click="emit('save')"
      >
        {{ t('SALES.DELIVERY.ACTIONS.SAVE') }}
      </LaisPrimaryButton>
      <LaisPrimaryButton
        icon="i-lucide-check-circle-2"
        :is-loading="delivering"
        :disabled="!canDeliver"
        @click="emit('deliver')"
      >
        {{ t('SALES.DELIVERY.ACTIONS.DELIVER') }}
      </LaisPrimaryButton>
    </template>
  </LaisHeader>
</template>
